import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class DownloadsService {
  constructor(
    private http: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private message: NzMessageService,
  ) {}

  getDownloads(page: number = 1, pageSize: number = 24): Promise<any> {
    this.ngxLoader.start();
    const url = `${SETTINGS.CMS_API}/api/downloads?page=${page}&limit=${pageSize}`;
    return new Promise((resolve, reject) => {
      return this.http.get(url).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve Downloads');
          reject(error);
        },
      );
    });
  }
}




